export class ExcelModel{
    phoneNumber: string;
    constructor( phoneNumber: string){
        this.phoneNumber = phoneNumber;
    }
}